var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { InputBase } from '../InputBase';
import styles from './TextArea.module.css';
import classNames from 'classnames';
export default React.forwardRef(function TextArea(props, ref) {
    // eslint-disable-next-line react/prop-types
    var placeholder = props.placeholder, rows = props.rows, id = props.id, textareaRef = props.textareaRef, textareaStyle = props.textareaStyle, baseProps = __rest(props, ["placeholder", "rows", "id", "textareaRef", "textareaStyle"]);
    var requiredForPlaceHolder = !baseProps.label && baseProps.required;
    var placeholderString = placeholder
        ? "".concat(placeholder, " ").concat(requiredForPlaceHolder ? '*' : '')
        : undefined;
    return (React.createElement(InputBase, __assign({}, baseProps, { forwardedRef: ref, inputComponent: function (restProps) { return (React.createElement(React.Fragment, null,
            React.createElement("textarea", __assign({ ref: textareaRef, rows: rows, placeholder: placeholderString }, restProps, { id: id, className: classNames(restProps.className, rows ? styles.textarea : styles.textareaDefault), spellCheck: 'true', style: textareaStyle })))); } })));
});
